// extracted by mini-css-extract-plugin
export default {"grid":"Services_grid__jQUOo","card":"Services_card__EbvVN","icon":"Services_icon__dhKwa","more":"Services_more__ZxS19","cta":"Services_cta__HLe2E"};